<template>
  <div class="layout-padding">
    <q-tabs color="white" underline-color="primary" class="settings-tabs round-borders no-scroll" ref="tabs">
      <q-tab name="general" slot="title" default :label="$t('general')" color="black"/>
      <q-tab name="security" slot="title" :label="$t('security')" color="black"/>
      <q-tab name="danger-zone" slot="title" :label="$t('danger_zone')" color="black"/>

      <general-settings @selectTab="selectTab"></general-settings>
      <security-settings></security-settings>
      <danger-zone-settings></danger-zone-settings>
    </q-tabs>
  </div>
</template>

<script>
  import DangerZoneSettings from 'components/Settings/Tabs/DangerZone.vue'
  import GeneralSettings from 'components/Settings/Tabs/General.vue'
  import SecuritySettings from 'components/Settings/Tabs/Security.vue'

  export default {
    methods: {
      selectTab (tab) {
        this.$refs.tabs.selectTab(tab)
      }
    },

    components: {
      DangerZoneSettings,
      GeneralSettings,
      SecuritySettings
    }
  }
</script>
